import { Button } from "@material-ui/core";
import { Checkbox, Grid, Paper, MenuItem, Select } from "@material-ui/core";
import { useState, useEffect, useCallback, useContext, Suspense, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ApproveEnrollment, PlanFormProps } from "../../../../../../../../../@types/components/enrollmentProps.types";
import { CommonDetails, Enrollment, StandardDetails } from "../../../../../../../../../@types/enrollment.types";
import { Member } from "../../../../../../../../../@types/member.types";
import { PaycheckContext, ThemeContext } from "../../../../../../../../../contexts";
import { dateFormateToMonthDayYear, getCurrentDate } from "../../../../../../../../../utils/commonFunctions/date";
import { numberToDollarStr } from "../../../../../../../../../utils/commonFunctions/dollar";
import { CustomInput } from "../../../../../../../../shared/customInput";
import { CoverageDetails } from "../../../../../../../../shared/enrollment";
import { CoveredDependents } from "../../../../../../../../shared/enrollment/coveredDependents";
import PlanActions from "../../../../../../../../shared/enrollment/planActions/PlanActions";
import PlanHeader from "../../../../../../../../shared/enrollment/planCode/PlanHeader";

import LinkIcon from "@material-ui/icons/Link";
import SendIcon from "@material-ui/icons/Send";

import "../../../../../../../../../globalStyles/memberPortalTheme.css";
import "../../../../../../../../../globalStyles/VEBTheme.css";
import useRouteParam from "../../../../../../../../../hooks/useRouteParam";
import { AdminEnrollmentInitDataQuery } from "../../../../../../../../../utils/api/pages/enrollmentInit";
import { api } from "../../../../../../../../../utils/api";
import { Plan, PremiumRateCoverage } from "../../../../../../../../../@types/plan.types";
import { getHealthPlanEligibleDependents } from "../../../../../../../../../utils/commonFunctions/groupEnrollment/eligibleDependents";
import { RELATIONSHIP } from "../../../../../../../../../constants/relationships";
import { LazyApproveEnrollment } from "../../../../../../..";
import { ApproveEnrollmentPayload } from "../../../../../../../../../utils/api/enrollment/enrollment";
import { getCommonDetails } from "../../../../../../../../../utils/commonFunctions/groupEnrollment/enrollmentPayload";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { Validation } from "../../../../../../../../../@types/validation.types";
import { Paycheck } from "../../../../../../../../../@types/paycheck.types";
import { trackPromise } from "react-promise-tracker";
import encryption from "../../../../../../../../../utils/commonFunctions/encryption";

import "./panhandleDentalPlanForm.css";
import { PanhandleFirstBankLogoDark, ProgressiveLaboratoriesLogo } from "../../../../../../../../../assets";
import { premiumDentalMap } from "../../../../../../../../../constants/panhandlePremiumAmount/panhandlePremiumAmount";

const PanhandleDentalPlanForm = (): JSX.Element => {
	const navigate = useNavigate();
	const [member, setMember] = useState<Member>();
	const queryPlanCode = useRouteParam("pc");
	const queryGroupNumber = useRouteParam("gn");
	const querySSN = useRouteParam("qs");
	const [approveEnrollment, setApproveEnrollment] = useState<ApproveEnrollment>();
	const [enrollmentStandardDetails, setEnrollmentStandardDetails] = useState<StandardDetails[]>([]);
	const [enrollmentCommonDetail, setEnrollmentCommonDetail] = useState<CommonDetails>();
	const [employeePremium, setEmployeePremium] = useState<number>(0);
	const { paycheck, setPaycheck } = useContext(PaycheckContext);
	const [enrollments, setEnrollments] = useState<Enrollment[]>([]);
	const [coveredDependents, setCoveredDependents] = useState<(Member & { covered: boolean })[]>([]);
	const [notCoveredDependents, setNotCoveredDependents] = useState<Member[]>([]);
	const [eligibleDependents, setEligibleDependents] = useState<(Member & { covered: boolean })[]>([]);
	const [coverageDetails, setCoverageDetails] = useState<any[]>([]);
	const [enrollmentDate, setEnrollmentDate] = useState("");
	const [plan, setPlan] = useState<Plan>();
	const { theme, setTheme } = useContext(ThemeContext);
	const [dependentPremium, setDependentPremium] = useState<number>(0);
	const [combinedTotalPremium, setCombinedTotalPremium] = useState(0);
	const [totalPremium, setTotalPremium] = useState<number>(0);
	const [validation, setValidation] = useState<Validation>({
		approvedEnrollment: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();

	// console.log("eligibleDependents", eligibleDependents);

	const handleApproveEnrollmentChange = useCallback(
		(
			event: React.ChangeEvent<
				| HTMLInputElement
				| {
						name?: string | undefined;
						value: unknown;
				  }
			>,
			child?: React.ReactNode
		) => {
			const { name, value } = event.target;
			// console.log(value);
			setApproveEnrollment(
				Object.assign({}, approveEnrollment, {
					[name as string]: value
				})
			);
		},
		[approveEnrollment]
	);

	const handleApproveEnrollmentDateChange = useCallback(
		(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
			const selectedDate = new Date(date as any);

			const parsedDate =
				selectedDate.getFullYear() + "-" + (selectedDate.getMonth() + 1) + "-" + selectedDate.getDate();

			setApproveEnrollment(
				Object.assign({}, approveEnrollment, {
					effective_date: parsedDate
				})
			);
		},
		[approveEnrollment]
	);

	const handleValidation = useCallback(async () => {
		_validation.current = {
			...validation,
			approveEnrollment: {},
			status: "invalid"
		};
		let flag = true;

		if (approveEnrollment === undefined) {
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (approveEnrollment?.enrollment_status === "" || approveEnrollment?.enrollment_status === "SUBMITTED") {
			_validation.current.approveEnrollment["enrollment_status"] = "Enrollment Status is required";
			_validation.current.status = "invalid";
			flag = false;
		}

		if (approveEnrollment?.enrollment_status === "ACTIVE" && approveEnrollment?.effective_date === null) {
			_validation.current.approveEnrollment["effective_date"] =
				"For active enrollment effective date is required";
			_validation.current.status = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			// alert("Please, fill effective date field !");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current.status;
	}, [approveEnrollment, validation]);

	const handleMemberDetailsRedirection = useCallback(() => {
		const pathname = `/employer/member?gn=${queryGroupNumber}&&qs=${
			encryption(querySSN as string) as string
		}&&to=benefits`;
		navigate(pathname);
	}, [navigate, queryGroupNumber, querySSN]);

	const handleSubmitEnrollmentClick = useCallback(
		async (event: React.FormEvent<HTMLButtonElement>) => {
			// console.log("approve", approveEnrollment);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const validation = await handleValidation();
			if (validation === "valid") {
				if (approveEnrollment === undefined || enrollmentCommonDetail === undefined) {
					return;
				}

				//eslint-disable-next-line arrow-parens
				const updatedStandardDetails = enrollmentStandardDetails.map((detail) => {
					if (detail.coverage_code === "ES") {
						return {
							...detail,
							premium_amount: combinedTotalPremium
						};
					}
					if (detail.coverage_code === "EC") {
						return {
							...detail,
							premium_amount: combinedTotalPremium
						};
					}
					return detail;
				});
				const approveEnrollmentPayload: ApproveEnrollmentPayload = {
					...approveEnrollment,
					common_detail: {
						...enrollmentCommonDetail,
						// sub_plan: subPlan,
						total_premium: combinedTotalPremium,
						premium_amount: combinedTotalPremium
					},
					dependent_standard_details: updatedStandardDetails,
					covered_dependent_SSNs: coveredDependents.map(({ SSN }: Member) => SSN)
				};

				// console.log("APPREOVETHING__>", approveEnrollmentPayload);

				// console.log("approveEnrollmentPayload", approveEnrollmentPayload);
				const response = await trackPromise(api.enrollments.approveEnrollment(approveEnrollmentPayload));
				if (response) {
					// console.log("response after clicking submit -> ", response);

					if (response.result.enrollment_status === "SUBMITTED") {
						alert("Dental Plan Approval Submitted!");
					}

					if (response.result.enrollment_status === "REJECTED") {
						alert("Dental Plan has been Rejected!");
					}

					// Redirection to Member Family Details
					handleMemberDetailsRedirection();
				}
			}
		},
		[
			approveEnrollment,
			combinedTotalPremium,
			coveredDependents,
			enrollmentCommonDetail,
			enrollmentStandardDetails,
			handleMemberDetailsRedirection,
			handleValidation
		]
	);

	const handleSelectDependent = useCallback((event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
		const { checked } = event.target;
		if (checked === true) {
			setCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) =>
				Object.assign([], [...prevCoveredDependents, { ...dependent, covered: true }])
			);
			setEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
				const newEligibleDependents = prevEligibleDependents.map(
					(prevEligibleDependent: Member & { covered: boolean }) => {
						if (dependent.SSN === prevEligibleDependent.SSN) {
							return { ...dependent, covered: true };
						} else {
							return prevEligibleDependent;
						}
					}
				);
				return newEligibleDependents;
			});
		} else {
			setCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) => {
				const _selectedDependents = prevCoveredDependents.filter(
					(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
				);
				// console.log("selectedDependent", _selectedDependents);
				return _selectedDependents;
			});
			setEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
				const newEligibleDependents = prevEligibleDependents.map(
					(prevEligibleDependent: Member & { covered: boolean }) => {
						if (dependent.SSN === prevEligibleDependent.SSN) {
							return { ...dependent, covered: false };
						} else {
							return prevEligibleDependent;
						}
					}
				);
				return newEligibleDependents;
			});
		}
	}, []);

	// const handleSelectDependent = useCallback((event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
	// 		const { checked } = event.target;
	// 		if (checked === true) {
	// 			setCoveredDependents((prevCoveredDependents: Member[]) =>
	// 				Object.assign([], [...prevCoveredDependents, dependent])
	// 			);
	// 		} else {
	// 			setCoveredDependents((prevCoveredDependents: Member[]) => {
	// 				const _selectedDependents = prevCoveredDependents.filter(
	// 					(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
	// 				);
	// 				return _selectedDependents;
	// 			});
	// 		}
	// 	}, []);
	const getPremiumAmount = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): string => {
			let premiumAmount = "";
			if (paycheck) {
				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount =
						(paycheck.pay_frequency === "BIWEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = `${numberToDollarStr(Number(premiumAmount))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount =
						(paycheck.pay_frequency === "BIWEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = premiumAmount + "%";
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getEligibleDependents = useCallback(
		(_coveredDependents: Member[], _notCoveredDependents: Member[], plan: Plan) => {
			if (plan === undefined) {
				return;
			}

			const _eligibleDependents = getHealthPlanEligibleDependents(_notCoveredDependents, plan.coverage);

			const notCoveredEligibleDependents = _eligibleDependents.map((dependents: Member) => ({
				...dependents,
				covered: false
			}));
			const coveredEligibleDependents = _coveredDependents.map((dependents: Member) => ({
				...dependents,
				covered: true
			}));
			setCoveredDependents(Object.assign([], coveredEligibleDependents));
			setEligibleDependents(Object.assign([], [...notCoveredEligibleDependents, ...coveredEligibleDependents]));
		},
		[]
	);

	// console.log("ENROLLMENTSCHECK__>", enrollments);

	const [subPlan, setSubPlan] = useState<string>("Plan 1");

	const getCoverageDetails = useCallback(() => {
		const _coverageDetails: any[] = [];

		if (paycheck === null || plan === undefined) {
			return;
		}
		const { coverage } = plan;
		// console.log("CHECK!@@@@_>", coverage);

		const premiums = premiumDentalMap;
		const paymentFrequency = "biweekly";

		if (coverage.EE.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EE);

			_coverageDetails.push({
				coverage: "Employee Only",
				premiumAmount: premiums[paymentFrequency].EE
			});
		}
		if (coverage.ES.active === true) {
			const premiumAmount = getPremiumAmount(coverage.ES);
			_coverageDetails.push({
				coverage: "Coverage For Spouse",
				// premiumAmount
				premiumAmount: premiums[paymentFrequency].ES
			});
		}
		if (coverage.EC.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EC);
			_coverageDetails.push({
				coverage: "Coverage For Child(ren)",
				premiumAmount: premiums[paymentFrequency].EC
			});
		}
		// if (coverage.ECH.active === true) {
		// 	const premiumAmount = getPremiumAmount(coverage.ECH);
		// 	_coverageDetails.push({
		// 		coverage: "Coverage For Two or More Children",
		// 		premiumAmount
		// 	});
		// }
		_coverageDetails.push({
			coverage: "Coverage For Family",
			premiumAmount: premiums[paymentFrequency].ED
		});
		// console.log(coverage);
		setCoverageDetails(Object.assign([], _coverageDetails));
	}, [getPremiumAmount, paycheck, plan]);

	const getDependents = useCallback(
		(enrollments: Enrollment[], dependents: Member[], employeeSSN: string, paycheck: Paycheck) => {
			const coveredDependentSSNs: string[] = [];
			const _coveredDependents: Member[] = [];
			setPlan(Object.assign({}, enrollments[0].plan));
			if (paycheck === null) {
				return;
			}
			enrollments.forEach((enrollment: Enrollment) => {
				const {
					_id,
					insured_SSN,
					plan_code,
					enrollment_date,
					member_SSN,
					premium_amount,
					enrollment_status,
					effective_date,
					employee
				} = enrollment;
				if (member_SSN !== employeeSSN) {
					coveredDependentSSNs.push(member_SSN);
				} else {
					setMember(Object.assign({}, employee));
					setApproveEnrollment((prevApproveEnrollment: ApproveEnrollment | undefined) =>
						Object.assign({}, prevApproveEnrollment, {
							_id,
							plan_code,
							insured_SSN,
							current_paycheck_id: paycheck._id,
							enrollment_status,
							effective_date
						})
					);
					setEnrollmentCommonDetail(getCommonDetails(enrollment));
					setEnrollmentDate(enrollment_date as unknown as string);
				}
			});
			// console.log("coveredDependentSSNs", coveredDependentSSNs);
			const _notCoveredDependents: Member[] = [];
			dependents.map((dependent: Member) => {
				if (coveredDependentSSNs.includes(dependent.SSN)) {
					// console.log("dependent.SSN", dependent.SSN);
					_coveredDependents.push(dependent);
				} else {
					_notCoveredDependents.push(dependent);
				}
			});
			// console.log("_coveredDependents", _coveredDependents);
			// console.log("_notCoveredDependents", _notCoveredDependents);
			//setCoveredDependents(Object.assign([], _coveredDependents));
			//setNotCoveredDependents(Object.assign([], _notCoveredDependents));
			if (enrollments[0].plan === undefined) {
				return;
			}
			getEligibleDependents(_coveredDependents, _notCoveredDependents, enrollments[0].plan);
		},
		[getEligibleDependents]
	);

	const getAdminEnrollmentInitData = useCallback(async () => {
		if (!queryGroupNumber || !queryPlanCode || !querySSN) {
			return;
		}
		//alert("hh");
		//getAdminEnrollmentInitData();
		const query: AdminEnrollmentInitDataQuery = {
			insured_SSN: querySSN as string,
			plan_code: queryPlanCode as string,
			group_number: queryGroupNumber as number
		};
		const { dependents, theme, enrollments, paycheck } = await trackPromise(
			api.pages.getAdminEnrollmentInitData(query)
		);
		setEnrollments(Object.assign([], enrollments));
		setTheme(Object.assign({}, theme));
		setPaycheck(Object.assign({}, paycheck));
		getDependents(enrollments, dependents, querySSN as string, paycheck);
	}, [getDependents, queryGroupNumber, queryPlanCode, querySSN, setPaycheck, setTheme]);

	const getPremiumRateByFixed = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = coverageCode.monthly_premium as number;
			} else if (paycheck.pay_frequency === "BIWEEKLY") {
				premiumAmount = coverageCode.weekly_premium as number;
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const premiumMap: Record<string, Record<string, Record<string, number>>> = {
		"Plan 1": {
			monthly: {
				EE: 100,
				ES: 150,
				EC: 200,
				ED: 250
			},
			weekly: {
				EE: 25,
				ES: 37.5,
				EC: 50,
				ED: 62.5
			}
		},
		"Plan 2": {
			monthly: {
				EE: 150,
				ES: 200,
				EC: 250,
				ED: 300
			},
			weekly: {
				EE: 37.5,
				ES: 50,
				EC: 62.5,
				ED: 75
			}
		}
	};

	const getPremiumRateByPercentage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
					premiumAmount = coverageCode.monthly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
					premiumAmount = coverageCode.monthly_minimum_premium as number;
				}
			} else if (paycheck.pay_frequency === "BIWEEKLY") {
				premiumAmount = (basePayRate * ((coverageCode.weekly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.weekly_maximum_premium as number)) {
					premiumAmount = coverageCode.weekly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.weekly_minimum_premium as number)) {
					premiumAmount = coverageCode.weekly_minimum_premium as number;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	// console.log("<<=======Total Premium======>>", totalPremium);
	// console.log("<<=======Employee Premium=====>>", employeePremium);
	// console.log("<<=======Dependent Premium=========>>", dependentPremium);

	const calculatePremiumByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}

			let premiumAmount: number | null;
			if (coverageCode.active === false) {
				alert("Member is not covered in this plan");
				return null;
			}
			if (coverageCode.premium_type === "PERCENTAGE") {
				premiumAmount = getPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				premiumAmount = getPremiumRateByFixed(basePayRate, coverageCode);
			} else {
				alert("Invalid premium type");
				return null;
			}
			return premiumAmount;
		},
		[getPremiumRateByFixed, getPremiumRateByPercentage, paycheck]
	);

	const getPremiumRateByFixedForBop = useCallback(
		(monthly_premium: number, weekly_premium: number): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = monthly_premium;
			} else if (paycheck.pay_frequency === "BIWEEKLY") {
				premiumAmount = weekly_premium;
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const calculatePremium = useCallback(() => {
		if (plan === undefined || paycheck === null) {
			return null;
		}

		const coveredChildren: Member[] = [];
		const childrenRelationships: string[] = [
			RELATIONSHIP.child,
			RELATIONSHIP.disabled_child,
			RELATIONSHIP.legal_custody_child,
			RELATIONSHIP.stepchild,
			RELATIONSHIP.court_ordered_dependent,
			RELATIONSHIP.grandchild
		];
		let coveredSpouse: Member | null = null;
		let basePayRate: number;
		if (paycheck?.pay_frequency === "BIWEEKLY") {
			basePayRate = paycheck.weekly_base_rate;
		} else if (paycheck?.pay_frequency === "MONTHLY") {
			basePayRate = paycheck.monthly_base_rate;
		} else {
			alert("Invalid Pay Frequency");
			return;
		}
		let employeePremium: number | null = 0;
		employeePremium = getPremiumRateByFixedForBop(premiumDentalMap.monthly.EE, premiumDentalMap.biweekly.EE);
		if (employeePremium === null) {
			return;
		}
		// console.log("coveredDependents", coveredDependents);
		coveredDependents.forEach((coveredDependent: Member) => {
			if (childrenRelationships.includes(coveredDependent.relationship as string)) {
				coveredChildren.push(coveredDependent);
			} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
				coveredSpouse = coveredDependent;
			}
		});

		const standardDetails: StandardDetails[] = [];
		let _dependentPremium = 0;
		if (coveredDependents.length !== 0) {
			if (coveredSpouse !== null) {
				const premiumAmount = getPremiumRateByFixedForBop(
					premiumDentalMap.monthly.ES,
					premiumDentalMap.biweekly.ES
				);
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				const spouseStandardDetails: StandardDetails = {
					member_object_id: coveredSpouse["_id"],
					coverage_code: "ES",
					member_SSN: coveredSpouse["SSN"],
					premium_amount: premiumAmount,
					is_tobacco: false
				};
				standardDetails.push(spouseStandardDetails);
				_dependentPremium = premiumAmount;
			}
			// if (coveredChildren.length !== 0) {
			// 	if (coveredChildren.length === 1) {
			// 		const premiumAmount = getPremiumRateByFixedForBop(
			// 			premiumDentalMap.monthly.EC,
			// 			premiumDentalMap.biweekly.EC
			// 		);
			// 		if (premiumAmount === null) {
			// 			alert("Invalid Premium Amount");
			// 			return null;
			// 		}
			// 		const spouseStandardDetails: StandardDetails = {
			// 			member_object_id: coveredChildren[0]._id as string,
			// 			coverage_code: "EC",
			// 			member_SSN: coveredChildren[0].SSN,
			// 			premium_amount: premiumAmount,
			// 			is_tobacco: false
			// 		};
			// 		_dependentPremium = premiumAmount;
			// 		standardDetails.push(spouseStandardDetails);
			// 	} else {
			// 		const premiumAmount = getPremiumRateByFixedForBop(
			// 			premiumDentalMap.monthly.ED,
			// 			premiumDentalMap.biweekly.ED
			// 		);
			// 		if (premiumAmount === null) {
			// 			alert("Invalid Premium Amount");
			// 			return null;
			// 		}
			// 		coveredChildren.forEach((coveredChild: Member) => {
			// 			const spouseStandardDetails: StandardDetails = {
			// 				member_object_id: coveredChild._id as string,
			// 				coverage_code: "ECH",
			// 				member_SSN: coveredChild.SSN,
			// 				premium_amount: premiumAmount,
			// 				is_tobacco: false
			// 			};
			// 			standardDetails.push(spouseStandardDetails);
			// 		});
			// 		_dependentPremium = premiumAmount;
			// 	}
			// }

			if (coveredChildren.length !== 0) {
				coveredChildren.forEach((coveredChild: Member) => {
					const premiumAmount = getPremiumRateByFixedForBop(
						premiumDentalMap.monthly.EC,
						premiumDentalMap.biweekly.EC
					);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					const childStandardDetails: StandardDetails = {
						member_object_id: coveredChild._id ? coveredChild._id : null,
						coverage_code: "EC",
						member_SSN: coveredChild.SSN,
						premium_amount: premiumAmount,
						is_tobacco: false
					};
					standardDetails.push(childStandardDetails);
					_dependentPremium = premiumAmount;
				});
			}

			if (coveredChildren.length !== 0 && coveredSpouse !== null) {
				const premiumAmount = getPremiumRateByFixedForBop(
					premiumDentalMap.monthly.ED,
					premiumDentalMap.biweekly.ED
				);
				// console.log("premiumAmount=====>", premiumAmount);
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				_dependentPremium = premiumAmount;
			}
			// console.log("standardDetails", standardDetails);
			setDependentPremium(_dependentPremium);
		}

		if (coveredDependents.length !== 0) {
			setTotalPremium(_dependentPremium);
		} else {
			setTotalPremium(employeePremium);
		}
		setEnrollmentStandardDetails(Object.assign([], standardDetails));
		setEmployeePremium(employeePremium);
		// setDependentPremium(_dependentPremium)
	}, [calculatePremiumByCoverage, coveredDependents, paycheck, plan]);

	// const calculatePremium = useCallback(() => {
	// 	if (plan === undefined || paycheck === null) {
	// 		return null;
	// 	}

	// 	const coveredChildren: Member[] = [];
	// 	const childrenRelationships: string[] = [
	// 		RELATIONSHIP.child,
	// 		RELATIONSHIP.disabled_child,
	// 		RELATIONSHIP.legal_custody_child,
	// 		RELATIONSHIP.stepchild,
	// 		RELATIONSHIP.court_ordered_dependent,
	// 		RELATIONSHIP.grandchild
	// 	];
	// 	let coveredSpouse: Member | null = null;
	// 	let basePayRate: number;
	// 	if (paycheck?.pay_frequency === "WEEKLY") {
	// 		basePayRate = paycheck.weekly_base_rate;
	// 	} else if (paycheck?.pay_frequency === "MONTHLY") {
	// 		basePayRate = paycheck.monthly_base_rate;
	// 	} else {
	// 		alert("Invalid Pay Frequency");
	// 		return;
	// 	}
	// 	let employeePremium: number | null = 0;
	// 	employeePremium = calculatePremiumByCoverage(basePayRate, plan.coverage.EE);
	// 	if (employeePremium === null) {
	// 		return;
	// 	}
	// 	console.log("coveredDependents", coveredDependents);
	// 	coveredDependents.forEach((coveredDependent: Member) => {
	// 		if (childrenRelationships.includes(coveredDependent.relationship as string)) {
	// 			coveredChildren.push(coveredDependent);
	// 		} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
	// 			coveredSpouse = coveredDependent;
	// 		}
	// 	});

	// 	const standardDetails: StandardDetails[] = [];
	// 	let _dependentPremium = 0;
	// 	if (coveredDependents.length !== 0) {
	// 		if (coveredSpouse !== null) {
	// 			const premiumAmount = calculatePremiumByCoverage(basePayRate, plan.coverage.ES);
	// 			if (premiumAmount === null) {
	// 				alert("Invalid Premium Amount");
	// 				return null;
	// 			}
	// 			const spouseStandardDetails: StandardDetails = {
	// 				member_object_id: coveredSpouse["_id"],
	// 				coverage_code: "ES",
	// 				member_SSN: coveredSpouse["SSN"],
	// 				premium_amount: premiumAmount,
	// 				is_tobacco: false
	// 			};
	// 			standardDetails.push(spouseStandardDetails);
	// 			_dependentPremium = _dependentPremium + premiumAmount;
	// 		}
	// 		if (coveredChildren.length !== 0) {
	// 			if (coveredChildren.length === 1) {
	// 				const premiumAmount = calculatePremiumByCoverage(basePayRate, plan.coverage.EC);
	// 				if (premiumAmount === null) {
	// 					alert("Invalid Premium Amount");
	// 					return null;
	// 				}
	// 				const spouseStandardDetails: StandardDetails = {
	// 					member_object_id: coveredChildren[0]._id as string,
	// 					coverage_code: "EC",
	// 					member_SSN: coveredChildren[0].SSN,
	// 					premium_amount: premiumAmount,
	// 					is_tobacco: false
	// 				};
	// 				_dependentPremium = _dependentPremium + premiumAmount;
	// 				standardDetails.push(spouseStandardDetails);
	// 			} else {
	// 				const premiumAmount = calculatePremiumByCoverage(basePayRate, plan.coverage.ECH);
	// 				if (premiumAmount === null) {
	// 					alert("Invalid Premium Amount");
	// 					return null;
	// 				}
	// 				coveredChildren.forEach((coveredChild: Member) => {
	// 					const spouseStandardDetails: StandardDetails = {
	// 						member_object_id: coveredChild._id as string,
	// 						coverage_code: "ECH",
	// 						member_SSN: coveredChild.SSN,
	// 						premium_amount: premiumAmount,
	// 						is_tobacco: false
	// 					};
	// 					standardDetails.push(spouseStandardDetails);
	// 				});
	// 				_dependentPremium = _dependentPremium + premiumAmount;
	// 			}
	// 		}

	// 		if (coveredChildren.length !== 0 && coveredSpouse !== null) {
	// 			const premiumAmount = calculatePremiumByCoverage(basePayRate, plan.coverage.ED);
	// 			console.log("premiumAmount=====>", premiumAmount);
	// 			if (premiumAmount === null) {
	// 				alert("Invalid Premium Amount");
	// 				return null;
	// 			}
	// 			_dependentPremium = premiumAmount;
	// 		}
	// 		console.log("standardDetails", standardDetails);
	// 		setDependentPremium(_dependentPremium);
	// 	}

	// 	if (coveredDependents.length !== 0) {
	// 		setTotalPremium(employeePremium + _dependentPremium);
	// 	} else {
	// 		setTotalPremium(employeePremium);
	// 	}
	// 	setEnrollmentStandardDetails(Object.assign([], standardDetails));
	// 	setEmployeePremium(employeePremium);
	// }, [calculatePremiumByCoverage, coveredDependents, paycheck, plan]);

	// const redirectBrochureDownloiad = () => {
	// 	const pdfURL = Health_Plan_Brochure_SBC;
	// 	const pdfTitle = "Health_Plan_Brochure SBC";
	// 	window.open(pdfURL, pdfTitle);
	// };

	const getCombinedTotal = useCallback(() => {
		if (totalPremium !== null) {
			setCombinedTotalPremium(totalPremium);
		}
	}, [totalPremium]);

	useEffect(() => {
		getCombinedTotal();
		calculatePremium();
	}, [calculatePremium, coveredDependents.length, getCombinedTotal]);

	useEffect(() => {
		getAdminEnrollmentInitData();
	}, [getAdminEnrollmentInitData]);

	useEffect(() => {
		// console.log("coveredDependents.length", coveredDependents.length);
		calculatePremium();
	}, [calculatePremium, coveredDependents.length]);

	useEffect(() => {
		if (!paycheck || !plan) {
			return;
		}
		getCoverageDetails();
	}, [getCoverageDetails, paycheck, plan]);

	if (plan === undefined) {
		return <></>;
	}

	return (
		<div className="health-benefit">
			<div className="paper-form-container">
				<Paper className="theme-border-radius paper-container" elevation={1}>
					<PlanHeader planName={plan?.plan_name} planCode={plan?.plan_code} />
					<div className="theme-plan-section-margin" />
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
						<img src={PanhandleFirstBankLogoDark} alt="" width="20%" />
					</div>
					<div className="theme-plan-section-margin" />
					<CoverageDetails coverageDetails={coverageDetails} />
					<div className="theme-plan-section-margin" />
					{eligibleDependents.length > 0 ? (
						<CoveredDependents
							dependents={eligibleDependents}
							handleSelectDependent={handleSelectDependent}
						/>
					) : null}

					<div className="theme-plan-inner-section-margin-2" />
					<Grid container className="theme-plan-inner-section-margin">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<div className="details-form-row">
								<div
									className="details-form-label theme-plan-total-premium align-right"
									style={{ color: theme.primary_color }}
								>
									Total Premium:{" "}
									{/* <span className="show-premium margin-adjust">
										{totalPremium == 0 ? "$0.00" : `$${totalPremium && totalPremium.toFixed(2)}`}
									</span> */}
									<span className="show-premium margin-adjust">
										{/* {combinedTotalPremium == 0
											? "$0.00"
											: `$${combinedTotalPremium && combinedTotalPremium.toFixed(2)}`} */}
										{totalPremium == 0 ? "$0.00" : `$${totalPremium && totalPremium.toFixed(2)}`}
									</span>
								</div>
							</div>
						</Grid>
					</Grid>
					{/* <div className="details-form-row" style={{ marginTop: "4rem", width: "100%" }}>
						<div className="details-form-label  required">Premium Amount</div>
						<CustomInput value={numberToDollarStr(totalPremium)} disabled />
					</div> */}
					<div className="theme-plan-section-margin" />
					<div className="plan-external-links">
						<div>
							<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="header">
							To Know More About The Benefits Offered, <a href="#">Click Here</a>
						</div>
					</div>

					<div className="theme-plan-inner-section-margin-2" />
					<div className="bullet-pointers-container">
						<h3>Please sign below </h3>
						<div className="herby-terms-conditions">
							I hereby,
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div className="bullet-pointer-text">
									Request to enroll in that{" "}
									<a
										href=""
										// onClick={redirectBrochureDownloiad}
									>
										BENEFIT PLAN
									</a>{" "}
									for which I am or may become eligible under the Plan created by the above{" "}
									<a
										href=""
										// onClick={redirectBrochureDownloiad}
									>
										PLAN SPONSOR
									</a>
								</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div className="bullet-pointer-text">
									Reafirm that I will abide by the provisions set forth in the{" "}
									<a
										href=""
										// onClick={redirectBrochureDownloiad}
									>
										SUMMARY PLAN DESCRIPTION
									</a>{" "}
									and{" "}
									<a
										href=""
										// onClick={redirectBrochureDownloiad}
									>
										PLAN DOCUMENT
									</a>
								</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div className="bullet-pointer-text">
									Authorize the required deductions, if any, from my earnings
								</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div className="bullet-pointer-text">
									Certify that the above dates of birth and other information are correct
								</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div className="bullet-pointer-text">
									I understand that cannot change or drop coverage prior to next open enrollment
									period unless a change of family and/or job status occur.
								</div>
							</div>
						</div>
					</div>

					<div className="theme-plan-option-content theme-plan-section-margin">
						<Checkbox defaultChecked style={{ paddingLeft: 0 }} />
						<p className="theme-plan-checkbox-label">
							<strong>
								I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE
								THE&nbsp;PAYROLL DEDUCTIONS TO BE MADE AS INDICATED
							</strong>
						</p>
					</div>

					<div className="theme-plan-section-margin" />
					<Grid container className="theme-plan-section-margin">
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">Signature</div>
								<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
							</div>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">Date</div>
								<CustomInput
									value={
										approveEnrollment ? dateFormateToMonthDayYear(enrollmentDate) : getCurrentDate()
									}
									disabled
								/>
							</div>
						</Grid>
					</Grid>
					<div
						className="theme-divider-grad-mask"
						style={{
							background: `linear-gradient(90deg, ${theme.primary_color} 0 55%, transparent 0 100%) 0 0 / 2rem 1rem`
						}}
					/>
					{approveEnrollment ? (
						<>
							<Suspense fallback={<div />}>
								<LazyApproveEnrollment
									enrollmentDate={enrollmentDate}
									approveEnrollment={approveEnrollment}
									handleApproveEnrollmentChange={handleApproveEnrollmentChange}
									handleApproveEnrollmentDateChange={handleApproveEnrollmentDateChange}
									validation={validation}
								/>
							</Suspense>
							<div className="theme-plan-section-margin" />
							<div className="enrollment-submit-button-container" id="enrollment-submit-button-container">
								<Button
									className="button-green"
									onClick={handleSubmitEnrollmentClick}
									variant="contained"
									style={{
										pointerEvents: "unset"
									}}
								>
									<span className="button-label-with-icon">Submit</span>
									<span>
										<SendIcon className="button-icon" />
									</span>
								</Button>
							</div>
						</>
					) : null}
				</Paper>
			</div>
		</div>
	);
};

export default PanhandleDentalPlanForm;
